import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Sigma, LogOut, LayoutDashboard } from "lucide-react";

const MODULES = [
  { to: "/learn", label: "Learn" },
  { to: "/solve", label: "Solve" },
  { to: "/verify", label: "Verify", roles: ["reviewer", "adjudicator", "admin"] },
  { to: "/research", label: "Research", roles: ["customer", "contributor", "adjudicator", "admin"] },
  { to: "/arena", label: "Arena" },
  { to: "/talent", label: "Talent" },
  { to: "/tribunal", label: "Tribunal", roles: ["adjudicator", "admin"] },
  { to: "/ledger", label: "Ledger" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const navigate = useNavigate();

  const visible = MODULES.filter((m) => !m.roles || (user && m.roles.includes(user.role)));

  return (
    <header className="glass-nav sticky top-0 z-50">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-[#CBD5E1] bg-slate-50">
            <Sigma className="h-5 w-5 text-[#E61A27]" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-lg tracking-wide text-slate-900">AXIOMS</span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]">Mahakali Studios</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {visible.map((m) => {
            const active = loc.pathname.startsWith(m.to);
            return (
              <Link
                key={m.to}
                to={m.to}
                data-testid={`nav-${m.label.toLowerCase()}`}
                className={`rounded-full px-4 py-2 text-sm transition-colors ${
                  active ? "bg-red-50 text-[#B45309]" : "text-slate-600 hover:text-slate-900"
                }`}
              >
                {m.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="hidden items-center gap-2 rounded-full border border-[#CBD5E1] px-4 py-2 text-sm text-slate-700 hover:border-[#D4AF37] sm:flex">
                <LayoutDashboard className="h-4 w-4" />
                <span className="capitalize">{user.role}</span>
              </Link>
              <button
                data-testid="nav-logout"
                onClick={async () => { await logout(); navigate("/"); }}
                className="flex items-center gap-2 rounded-full px-3 py-2 text-sm text-slate-600 hover:text-[#E61A27]"
                title="Sign out"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="rounded-full px-4 py-2 text-sm text-slate-700 hover:text-slate-900">
                Sign in
              </Link>
              <Link to="/register" data-testid="nav-register" className="btn-crimson !px-5 !py-2 text-sm">
                Join
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
